<script setup>
import InvestmentProcessHeadline from '../InvestmentProcessHeadline.vue'
import InvestmentProcessWrapper from '../InvestmentProcessWrapper.vue'
import InvestmentProcessSteps from '../InvestmentProcessSteps.vue'
import InvestmentProcessStepsMobile from '../InvestmentProcessStepsMobile.vue'
import {
    initializeInvestmentProcessNavigation,
    useInvestmentProcessNavigation,
} from '../../../utilities/account/useInvestmentProcessNavigation'
import ECSPInvestmentProcessInvestmentAmount from './ECSPInvestmentProcessInvestmentAmount.vue'
import ECSPInvestmentProcessLegal from './ECSPInvestmentProcessLegal.vue'
import ECSPInvestmentProcessSummary from './ECSPInvestmentProcessSummary.vue'
import ECSPInvestmentProcessPayment from './ECSPInvestmentProcessPayment.vue'
import NaturalProfileSidebarCard from '../sidebar/NaturalProfileSidebarCard.vue'
import { isLegalProfile, isNaturalProfile } from '../../../utilities/investment-process/useUserProfileType'
import LegalProfileSidebarCard from '../sidebar/LegalProfileSidebarCard.vue'
import { useInvestmentProcessDataState } from '../../../utilities/investment-process/useInvestmentProcess'
import { i18n } from '../../../localization'
import CampaignSidebarCard from '../sidebar/CampaignSidebarCard.vue'
import { useNyalaCustomerVaultData } from '../../../utilities/account/useNyalaCustomerVaultData'

const investmentProcessDataStore = useInvestmentProcessDataState()
const nyalaCustomerVaultDataStore = useNyalaCustomerVaultData()

investmentProcessDataStore.loadPendingInvestment()
investmentProcessDataStore.$subscribe(investmentProcessDataStore.setPendingInvestment)

nyalaCustomerVaultDataStore.fetchVaultData()

const steps = [
    {
        name: 'investmentAmount',
        label: i18n.global.t('investment_process.investment_amount'),
        component: ECSPInvestmentProcessInvestmentAmount,
    },
    {
        name: 'legal',
        label: i18n.global.t('investment_process.law_requirements'),
        component: ECSPInvestmentProcessLegal,
    },
    { name: 'summary', label: i18n.global.t('investment_process.summary'), component: ECSPInvestmentProcessSummary },
    { name: 'payment', label: i18n.global.t('investment_process.payment'), component: ECSPInvestmentProcessPayment },
]

initializeInvestmentProcessNavigation(steps)
</script>

<template>
    <InvestmentProcessWrapper
        v-if="nyalaCustomerVaultDataStore.loading === false && nyalaCustomerVaultDataStore.is_created !== false">
        <template #header>
            <InvestmentProcessHeadline />
            <InvestmentProcessSteps />
            <InvestmentProcessStepsMobile />
        </template>
        <template #main>
            <component :is="useInvestmentProcessNavigation().currentStep.component"></component>
        </template>
        <template #sidebar>
            <div class="space-y-6">
                <NaturalProfileSidebarCard v-if="isNaturalProfile()"></NaturalProfileSidebarCard>
                <LegalProfileSidebarCard v-if="isLegalProfile()"></LegalProfileSidebarCard>
                <CampaignSidebarCard></CampaignSidebarCard>
            </div>
        </template>
    </InvestmentProcessWrapper>
    <div v-else-if="nyalaCustomerVaultDataStore.is_created === false" class="py-4 text-center text-gray-700">
        {{ $t('nyala_vault.vault_not_created_yet_at_nyala') }}
    </div>
</template>

<style scoped></style>
